import styled from 'styled-components';
import { PAGE_SIZES, PaginationFooter, PaginationUpdateEvent } from 'ui/paginationFooter';

const StyledPagination = styled(PaginationFooter)`
  border-top: none;
`;

export type Props = {
  currentPage: number;
  itemsPerPage: number;
  numItems: number;
  onUpdate: (e: PaginationUpdateEvent) => void;
};

export const ChannelsPagination = ({ currentPage, itemsPerPage, numItems, onUpdate }: Props) => (
  <>
    {numItems > 0 && (
      <StyledPagination
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        numItems={numItems}
        pageSizes={PAGE_SIZES}
        onUpdate={onUpdate}
      />
    )}
  </>
);
